<template>  
    <div class="inputDynamicSearch">
        <span v-if="selectedResult">{{ selectedResult[props.showProp] }}
            <i class="material-icons float-left" @click="selectedResult = null; selectResult()">close</i>
        </span>
        <template v-else>
            <i class="material-icons float-left">search</i>
            <input type="text" v-model="text" @input="getData()" :placeholder="$t('inputDynamicSearch.PLACEHOLDER')">
            <label class="label" :class="{'stay-top': text}">{{$t('inputDynamicSearch.LABEL')}}</label>
            <ul v-if="text.length > 2 && (results || loading || reqError)">
                <Loader v-if="loading" type="dots" />
                <template v-else-if="!reqError">
                    <li v-for="(result, idx) in results" :key="idx" @click="selectedResult = result; selectResult()">{{ result[props.showProp] }}</li>                    
                </template>
                <summary v-if="reqError"><i class="material-icons-outlined">error</i>{{$t('global.ERROR_OCCURRED')}}</summary>
                <summary v-else-if="!results?.length && !loading && text.length > 2"><i class="material-icons-outlined">info</i>{{$t('inputDynamicSearch.NO_RESULTS')}}</summary>
            </ul>
        </template>
    </div>
</template>

<script setup>
import Loader from '@/components/Loader.vue'
import { ref, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
// eslint-disable-next-line no-unused-vars
const { t } = useI18n();

const store = useStore();
const emit = defineEmits(['selectResult'])
const props = defineProps({
    storeReqPath: String,
    showProp: String,
})

const text = ref('');
const results = ref([]);
const selectedResult = ref(null);
const loading = ref(false);
const reqError = ref(false);

function selectResult(){
    emit('selectResult', selectedResult.value);
    text.value = '';
    results.value = [];
}

let timeoutId;

async function getData(){
    reqError.value = false;
    if(!text.value.length){
        results.value = [];
        return;
    }
    if(text.value.length < 3) return;
    clearTimeout(timeoutId);
    loading.value = true;
    timeoutId = setTimeout(async() => {
        try {
            let req = await store.dispatch(props.storeReqPath, text.value);       
            results.value = req.data;
        } catch (error) {
            console.log(error);
            reqError.value = true;
        } finally {
            loading.value = false;            
        }
    }, 1300);
}

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.inputDynamicSearch{
    position: relative;
    width: 100%;
    .material-icons.float-left{
        position: absolute;
        right: 20px;
        top: 13px;
    }
    span{
        display: flex;
        align-items: center;
        width: 100%;
        background: #f5f5f5;
        padding: 12px 48px 12px 28px;
        font-size: 13px;
        font-weight: 400;
        line-height: 25px;
        border-radius: 50px;
        .material-icons{
            cursor: pointer;
        }
    }
    summary{
        padding: 2px 12px;
        @include icon-and-text-container;
        font-size: 14px;
        .material-icons-outlined{
            font-size: 20px;
        }
    }
    label{
        cursor: text;
        position: absolute;
        top: 0;
        left: 28px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        transform: translateY(12px);
        transition: transform .5s, color .3s, font-size .5s;
        line-height: 25px;
        font-size: 13px;
        pointer-events: none;
        &.stay-top{
            transform: translateY(3px);
            font-size: 10px;
            color: var(--green);
        }
    } 
    input{
        width: 100%;
        background: #f5f5f5;
        padding: 18px 48px 6px 28px;
        border: none;
        outline: none;
        border-radius: 50px;
        font-size: 13px;
        font-weight: 400;
        line-height: 25px;
        transition: all .2s;
        font-family: 'Open Sans', sans-serif;
        height: 50px !important;
        &::placeholder{
            font-size: 12px;
            color: transparent;
        }
        &:focus{
            &::placeholder{
                color: rgba(0, 0, 0, 0.5);
            }
        }
        &:focus + label{
            transform: translateY(3px);
            font-size: 10px;
            color: var(--green);
        }
        &:hover{
            background-color: #ddd;
        }
    }
    ul{
        width: 100%;
        position: absolute;
        top: 54px;
        padding: 12px 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        background: #f5f5f5;
        box-shadow: 0px 4px 4px 0px #00000040;
        border-radius: 10px;
        z-index: 20;
        li{
            font-size: 13px;
            padding: 2px 12px;
            cursor: pointer;
            &:hover{
                background: #fff;
            }
        }
    }
}
.dots{
    height: 6px;
    margin: 12px auto;
}

</style>